import { httpRequest } from "@services/http";
import type { NetworkTemplate } from "@models/networkTemplate.model";

export interface UpdateNetworkTemplatePayload {
  // `data` is a FULL REPLACE of the template's data. `name` is an optional
  // rename. Omitted fields are left untouched server-side.
  data?: Record<string, any>;
  name?: string;
}

export class CommandUpdateNetworkTemplate {
  async run(templateId: number, payload: UpdateNetworkTemplatePayload): Promise<NetworkTemplate> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_templates/${templateId}/`;
    return await httpRequest<NetworkTemplate>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
  }
}
